<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Blog Yazıları</h1>
      </div>
      <div class="col-sm-6">
        <div class="float-right">
          <button class="btn btn-secondary mr-2" (click)="openCategoryManageModal()">
            <i class="fas fa-tags"></i> Kategorileri Yönet
          </button>
          <button class="btn btn-success mr-2" (click)="openAiGenerateModal()">
            <i class="fas fa-robot"></i> AI ile Oluştur
          </button>
          <button class="btn btn-primary" (click)="openCreateModal()">
            <i class="fas fa-plus"></i> Yeni Blog Yazısı
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6">
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     placeholder="Blog ara..."
                     [(ngModel)]="searchTerm"
                     (keyup.enter)="onSearch()">
              <div class="input-group-append">
                <button class="btn btn-primary" (click)="onSearch()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div *ngIf="loading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Yükleniyor...</span>
          </div>
        </div>

        <div *ngIf="!loading && posts.length === 0" class="alert alert-info">
          Henüz blog yazısı bulunmamaktadır.
        </div>

        <div *ngIf="!loading && posts.length > 0" class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th style="width: 80px">Görsel</th>
                <th>Başlık</th>
                <th>Kategori</th>
                <th>Yazar</th>
                <th style="width: 100px">Durum</th>
                <th style="width: 100px">Öne Çıkan</th>
                <th style="width: 120px">Tarih</th>
                <th style="width: 150px">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let post of posts">
                <td>
                  <img *ngIf="post.featuredImage"
                       [src]="post.featuredImage"
                       class="img-thumbnail"
                       style="width: 60px; height: 60px; object-fit: cover;">
                  <span *ngIf="!post.featuredImage" class="text-muted">-</span>
                </td>
                <td>
                  <strong>{{ post?.title }}</strong>
                  <br>
                  <small class="text-muted">{{ post?.summary | slice:0:100 }}...</small>
                  <br>
                  <span *ngFor="let tag of post.tags" class="badge badge-secondary mr-1">{{ tag }}</span>
                </td>
                <td>{{ post.categoryName }}</td>
                <td>{{ post.authorName }}</td>
                <td>
                  <span [class]="'badge ' + getStatusBadge(post)">
                    {{ getStatusText(post) }}
                  </span>
                </td>
                <td class="text-center">
                  <i [class]="post.isFeatured ? 'fas fa-star text-warning' : 'far fa-star'"></i>
                </td>
                <td>
                  <small>{{ post.publishedDate | date:'dd/MM/yyyy' }}</small>
                </td>
                <td>
                  <button class="btn btn-sm btn-info mr-1"
                          (click)="openEditModal(post)"
                          title="Düzenle">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-danger"
                          (click)="deletePost(post)"
                          title="Sil">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div *ngIf="totalPages > 1" class="d-flex justify-content-center mt-3">
          <nav>
            <ul class="pagination">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="onPageChange(currentPage - 1)" href="javascript:void(0)">Önceki</a>
              </li>
              <li *ngFor="let page of [].constructor(totalPages); let i = index"
                  class="page-item"
                  [class.active]="i + 1 === currentPage">
                <a class="page-link" (click)="onPageChange(i + 1)" href="javascript:void(0)">{{ i + 1 }}</a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="onPageChange(currentPage + 1)" href="javascript:void(0)">Sonraki</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>
